<template>
  <main id="about-us" style="background-color: #274c8e">
    <div class="bg-canvas">
      <div class="bg-gradient">
        <section id="about-us-section">
          <CardJumboTron :imageSrc="FraudBg">
            <h1
              class="text-white text-title"
              style="line-height: 100%; text-transform: capitalize"
            >
              <span class="text-orange">Whistleblowing</span> System
            </h1>
            <p class="text-desc mt-3">
              Laporkan dugaan pelanggaran kecurangan
              <i><span class="text-orange">(fraud)</span></i
              >, pelanggaran kode etik, maupun pelanggaran benturan kepentingan
              yang dilakukan oleh Oknum Internal maupun External
              <span class="text-orange fw-bold">Efunding</span> yang merugikan.
            </p>
            <button @click="navigateToFaq" class="button-primary">
              Laporkan Disini
            </button>
          </CardJumboTron>
        </section>
      </div>
    </div>

    <section id="efunding-anti-fraud-commitment" class="container">
      <h2 class="section-header">
        Komitmen <span class="section-header-orange">Efunding</span>
      </h2>
      <p class="section-desc">
        Efunding berkomitmen tinggi dalam membangun lingkungan bisnis yang
        berintegritas dan bebas dari praktik yang tidak etis, guna menciptakan
        kepercayaan dalam penyelenggaraan layanan yang berkualitas.
      </p>
      <p class="section-desc">
        Sebagai bagian dari komitmen tersebut, Efunding menyediakan sarana
        pelaporan melalui Whistleblowing System (WBS). Sistem ini memberikan
        kesempatan kepada seluruh pihak untuk melaporkan dugaan pelanggaran,
        termasuk tindak kecurangan
        <i><span style="color: #f7bd3a !important">(fraud)</span></i
        >, pelanggaran kode etik, maupun konflik kepentingan yang dilakukan oleh
        pihak internal maupun eksternal yang dapat merugikan perusahaan.
      </p>
    </section>

    <section id="efunding-anti-fraud-announcement" class="container">
      <h2 class="section-header">
        Perlu <span class="section-header-orange">Diperhatikan!</span>
      </h2>
      <p class="section-desc">
        Beberapa hal yang perlu diperhatikan sebelum melakukan pelaporan
      </p>
      <ol>
        <li class="section-desc">
          <p class="section-desc" style="text-align: start">
            Apa tindakan atau perbuatan indikasi yang diketahui?
          </p>
        </li>
        <li class="section-desc">
          <p class="section-desc" style="text-align: start">
            Dimana tindakan itu terjadi?
          </p>
        </li>
        <li class="section-desc">
          <p class="section-desc" style="text-align: start">
            Kapan tindakan tersebut dilakukan?
          </p>
        </li>
        <li class="section-desc">
          <p class="section-desc" style="text-align: start">
            Siapa saja pihak yang terlibat?
          </p>
        </li>
        <li class="section-desc">
          <p class="section-desc" style="text-align: start">
            Bagaimana tindakan tersebut dilakukan?
          </p>
        </li>
      </ol>
    </section>

    <section id="fraud-privacy" class="container">
      <div class="privacy-card-container">
        <p class="section-desc" style="text-align: start">
          <b>Kerahasiaan Pelapor Dijamin</b> <br />
          Semua informasi yang Kamu sampaikan, termasuk identitas, akan
          dirahasiakan dengan ketat. Kamu juga memiliki opsi untuk melaporkan
          secara anonim
        </p>
      </div>
    </section>

    <section id="whistleblower-qr">
      <p class="section-desc" style="font-weight: 600; margin-bottom: 3rem">
        Kirim Laporan Kamu Melalui Metode di Bawah
      </p>

      <!-- Whistleblowing Form -->
      <div id="whistleblowing-form-section" class="whistleblowing-form-container">
        <div class="whistleblowing-card">
          <h3 class="form-title">
            Form Pengaduan <span class="text-orange">Whistleblowing</span>
          </h3>
          <form class="whistleblowing-form" novalidate @submit.prevent="submitWhistleblowing">
            <!-- Nama Pelapor (Optional) -->
            <div class="form-group">
              <label for="reporter_name">Nama Pelapor <span class="optional-label">(opsional)</span></label>
              <input
                type="text"
                id="reporter_name"
                name="reporter_name"
                v-model="whistleblowingForm.reporter_name"
                placeholder="Nama Lengkap Pelapor"
              />
            </div>

            <!-- Telepon Pelapor -->
            <div class="form-group">
              <label for="reporter_phone">Telepon Pelapor <span class="required-star">*</span></label>
              <input
                type="text"
                id="reporter_phone"
                name="reporter_phone"
                v-model="whistleblowingForm.reporter_phone"
                placeholder="Tulis Nomor Telepon"
                required
                @keypress="onlyNumberKey"
                @input="handlePhoneInput"
              />
            </div>

            <!-- Email Pelapor -->
            <div class="form-group">
              <label for="reporter_email">Email Pelapor <span class="required-star">*</span></label>
              <input
                type="email"
                id="reporter_email"
                name="reporter_email"
                v-model="whistleblowingForm.reporter_email"
                placeholder="Masukan Email Pelapor"
                required
                @input="handleEmailInput"
                @blur="handleEmailBlur"
                :class="{
                  'is-valid': whistleblowingForm.reporter_email && emailValid,
                  'is-invalid': showEmailError,
                }"
              />
              <small v-if="showEmailError" class="invalid-feedback">
                Format email tidak valid (contoh: nama@domain.com).
              </small>
            </div>

            <!-- Tindakan / Perbuatan yang Dilaporkan -->
            <div class="form-group">
              <label for="violation_type">Tindakan / Perbuatan yang Dilaporkan <span class="required-star">*</span></label>
              <select
                id="violation_type"
                name="violation_type"
                v-model="whistleblowingForm.violation_type"
                required
              >
                <option value="" disabled selected>Pilih Jenis Pelanggaran</option>
                <option value="fraud">Fraud</option>
                <option value="pelanggaran_kode_etik">Pelanggaran Kode Etik</option>
                <option value="pelanggaran_benturan_kepentingan">Pelanggaran Benturan Kepentingan</option>
                <option value="pelanggaran_hukum">Pelanggaran Hukum</option>
              </select>
            </div>

            <!-- Nama Terlapor -->
            <div class="form-group">
              <label for="reported_name">Nama Terlapor <span class="required-star">*</span></label>
              <input
                type="text"
                id="reported_name"
                name="reported_name"
                v-model="whistleblowingForm.reported_name"
                placeholder="Nama Lengkap Terlapor"
                required
              />
            </div>

            <!-- Jabatan Terlapor -->
            <div class="form-group">
              <label for="reported_position">Jabatan Terlapor <span class="required-star">*</span></label>
              <input
                type="text"
                id="reported_position"
                name="reported_position"
                v-model="whistleblowingForm.reported_position"
                placeholder="Jabatan Terlapor"
                required
              />
            </div>

            <!-- Waktu Kejadian -->
            <div class="form-group">
              <label for="incident_time">Waktu Kejadian (tanggal dan periode) <span class="required-star">*</span></label>
              <input
                type="text"
                id="incident_time"
                name="incident_time"
                v-model="whistleblowingForm.incident_time"
                placeholder="contoh: 5-20 Januari 2017 atau Selama bulan Desember di tahun 2017"
                required
              />
            </div>

            <!-- Lokasi Kejadian -->
            <div class="form-group">
              <label for="incident_location">Lokasi Kejadian <span class="required-star">*</span></label>
              <input
                type="text"
                id="incident_location"
                name="incident_location"
                v-model="whistleblowingForm.incident_location"
                placeholder="Lokasi tempat kejadian berlangsung"
                required
              />
            </div>

            <!-- Kronologis Kejadian -->
            <div class="form-group">
              <label for="incident_chronology">Kronologis Kejadian <span class="required-star">*</span></label>
              <textarea
                id="incident_chronology"
                name="incident_chronology"
                v-model="whistleblowingForm.incident_chronology"
                placeholder="Ceritakan tentang detail kejadian di sini"
                required
              ></textarea>
            </div>

            <!-- Nominal (Optional) -->
            <div class="form-group">
              <label for="nominal">Nominal <span class="optional-label">(opsional)</span></label>
              <input
                type="text"
                id="nominal"
                name="nominal"
                v-model="whistleblowingForm.nominal"
                placeholder="contoh: kurang lebih 10juta rupiah"
              />
            </div>

            <div class="form-submit">
              <button
                type="submit"
                class="btn-submit"
                :disabled="whistleblowingLoading"
              >
                {{ whistleblowingLoading ? "Mengirim..." : "Kirim Laporan" }}
              </button>
            </div>
          </form>
        </div>
      </div>

    </section>

    <!-- Modal Berhasil -->
    <NewCustomModal :visible="alertWhistleblowing" size="medium">
      <div class="success-modal-container">
        <img
          :src="require('@/assets/images/success-icon.png')"
          alt="Berhasil"
          class="success-icon"
        />

        <div class="success-text">
          <span class="success-title">Laporan Berhasil</span>
          <span class="success-subtitle">Dikirim!</span>
        </div>

        <div class="success-message-box">
          <span class="text-value">{{ whistleblowingMessage }}</span>
        </div>

        <div class="modal-action-buttons success-modal">
          <button
            class="custom-btn btn-close-modal"
            @click="closeWhistleblowingModal"
            :disabled="whistleblowingLoading"
          >
            Tutup
          </button>
        </div>
      </div>
    </NewCustomModal>

    <!-- Modal Error -->
    <NewCustomModal :visible="alertWhistleblowingError" size="medium">
      <div class="error-modal-container">
        <img
          :src="require('@/assets/images/wrong-icon.png')"
          alt="Gagal"
          class="error-icon"
        />

        <div class="error-text">
          <span class="error-title">Laporan Gagal</span>
          <span class="error-subtitle">Dikirim!</span>
        </div>

        <div class="error-message-box">
          <span class="text-value">{{ whistleblowingErrorMessage }}</span>
        </div>

        <div class="modal-action-buttons error-modal">
          <button
            class="custom-btn btn-close-modal"
            @click="closeWhistleblowingModal"
            :disabled="whistleblowingLoading"
          >
            Tutup
          </button>
        </div>
      </div>
    </NewCustomModal>

    <CardGetStarted />

    <NewFooterClient />
  </main>
</template>

<script>
// Assets
import FraudBg from "../assets/images/landing_page/img-fraud.png";
import VisionImg from "../assets/images/landing_page/img-mission.png";
import MissionImg from "../assets/images/landing_page/img-vision.png";
import QRFraud from "../assets/images/landing_page/img-qr-fraud.png";

// Components
import CardJumboTron from "@/components/landing-page/cardJumbotron.vue";
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";
import CardFaq from "@/components/landing-page/cardFaq.vue";
import CardGetStarted from "@/components/landing-page/cardGetStarted.vue";
import CardAvatarImage from "@/components/landing-page/cardAvatarImage.vue";
import NewCustomModal from "@/components/newCustomModal.vue";

// API
import whistleblowing from "@/api/whistleblowing";

// Utils
import { efundingFaq } from "@/utils/efunding_faq.js";
import { efundingHierarchy } from "@/utils/efunding_hierarchy";

export default {
  name: "Whistleblower",
  components: {
    CardJumboTron,
    NewFooterClient,
    CardFaq,
    CardAvatarImage,
    CardGetStarted,
    NewCustomModal,
  },
  data() {
    return {
      // Assets
      FraudBg,
      VisionImg,
      MissionImg,
      QRFraud,

      // Data
      efundingFaq,
      efundingHierarchy,

      // Whistleblowing Form
      whistleblowingForm: {
        reporter_name: "",
        reporter_phone: "",
        reporter_email: "",
        violation_type: "",
        reported_name: "",
        reported_position: "",
        incident_time: "",
        incident_location: "",
        incident_chronology: "",
        nominal: "",
      },
      whistleblowingLoading: false,
      alertWhistleblowing: false,
      alertWhistleblowingError: false,
      whistleblowingMessage: null,
      whistleblowingErrorMessage: null,
      showEmailError: false,
      emailTimer: null,
    };
  },

  computed: {
    emailValid() {
      const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return pattern.test(this.whistleblowingForm.reporter_email);
    },
  },

  beforeDestroy() {
    if (this.emailTimer) {
      clearTimeout(this.emailTimer);
    }
  },

  methods: {
    onlyNumberKey(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },

    navigateToFaq() {
      const formSection = document.getElementById("whistleblowing-form-section");
      if (formSection) {
        formSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },

    handlePhoneInput() {
      let value = (this.whistleblowingForm.reporter_phone || "").replace(/\D/g, "");
      if (value.startsWith("0")) {
        value = "62" + value.replace(/^0+/, "");
      } else if (value && !value.startsWith("62")) {
        value = "62" + value;
      }
      this.whistleblowingForm.reporter_phone = value;
    },

    handleEmailInput() {
      if (this.emailTimer) {
        clearTimeout(this.emailTimer);
      }
      if (!this.whistleblowingForm.reporter_email) {
        this.showEmailError = false;
        return;
      }
      if (this.emailValid) {
        this.showEmailError = false;
      } else {
        this.showEmailError = false;
        this.emailTimer = setTimeout(() => {
          if (this.whistleblowingForm.reporter_email && !this.emailValid) {
            this.showEmailError = true;
          }
        }, 600);
      }
    },

    handleEmailBlur() {
      if (this.emailTimer) {
        clearTimeout(this.emailTimer);
      }
      if (this.whistleblowingForm.reporter_email && !this.emailValid) {
        this.showEmailError = true;
      } else {
        this.showEmailError = false;
      }
    },

    async submitWhistleblowing() {
      // Validate email before submit
      if (!this.emailValid) {
        this.showEmailError = true;
        this.alertWhistleblowingError = true;
        this.whistleblowingErrorMessage = "Format email tidak valid. Silakan periksa kembali.";
        return;
      }

      this.whistleblowingLoading = true;
      try {
        const response = await whistleblowing.store(this.whistleblowingForm);
        console.log(
          "hasil response whistleblowing",
          response.data.meta.code,
          response.data.meta.message
        );
        if (response.data.meta.code === 200) {
          this.alertWhistleblowing = true;
          this.whistleblowingMessage = response.data.meta.message || "Terima kasih! Laporan Anda telah berhasil dikirim dan akan segera ditindaklanjuti.";
          // Reset form
          this.resetWhistleblowingForm();
        } else {
          this.alertWhistleblowingError = true;
          this.whistleblowingErrorMessage = response.data.meta.message || "Terjadi kesalahan. Silakan coba lagi.";
        }
      } catch (error) {
        console.error("Gagal mengirim laporan whistleblowing:", error);
        this.alertWhistleblowingError = true;
        this.whistleblowingErrorMessage = "Terjadi kesalahan pada server. Silakan coba lagi nanti.";
      } finally {
        this.whistleblowingLoading = false;
      }
    },

    resetWhistleblowingForm() {
      if (this.emailTimer) {
        clearTimeout(this.emailTimer);
      }
      this.showEmailError = false;
      this.whistleblowingForm = {
        reporter_name: "",
        reporter_phone: "",
        reporter_email: "",
        violation_type: "",
        reported_name: "",
        reported_position: "",
        incident_time: "",
        incident_location: "",
        incident_chronology: "",
        nominal: "",
      };
    },

    closeWhistleblowingModal() {
      this.alertWhistleblowing = false;
      this.alertWhistleblowingError = false;
    },
  },
};
</script>

<style scoped>
.bg-canvas {
  background-image: url("../assets/images/landing_page/img-bg-canvas.png");
}
.bg-gradient {
  background: linear-gradient(
    to top,
    rgba(39, 76, 142, 1) 49%,
    rgba(39, 76, 142, 0)
  );
}

.section-description {
  color: #b3b3b3;
  text-align: center;
}
.container {
  max-width: 90%;
}

.visi-misi-section {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 2rem 1rem;
}

.row-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
  margin: 0 10%;
}

.row-section.reverse {
  flex-direction: row-reverse;
}

.image {
  flex: 1;
  max-width: 400px;
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.content {
  flex: 1;
  min-width: 280px;
  max-width: 50%;
}

.title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.mission-list {
  padding-left: 1.5rem;
}

.mission-list li {
  margin-bottom: 0.8rem;
  line-height: 1.6;
}

/* Button Style */
.button-primary {
  padding: 15px 25px;
  background-color: #f7bd3a;
  color: white;
  font-weight: 600;
  transition: all 0.5s;
  border: none;
  border-radius: 50px;
}
.button-primary:hover {
  transform: scale(105%);
}

.qr-img-container {
  display: flex;
  width: 100%;
  justify-content: center;
}

@media (max-width: 767px) {
  .text-desc {
    font-size: 20px;
    line-height: 105%;
    color: white;
  }
  .section-header {
    font-size: 32px;
    line-height: 105%;
    color: white;
    font-weight: 700;
    margin-bottom: 1.5rem;
    text-align: center;
    text-transform: capitalize;
    letter-spacing: 0;
  }

  .section-header-orange {
    color: #f7bd3a;
    font-weight: 700;
    margin-bottom: 0.5rem;
    text-align: center;
  }

  .section-desc {
    font-size: 18px;
    color: white;
    text-align: center;
    line-height: 110%;
  }

  #efunding-anti-fraud-announcement {
    max-width: 100%;
    margin: auto;
    list-style-position: outside;
  }

  .privacy-card-container {
    background-color: #0288db;
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: center;
    border-radius: 16px;
  }
}

@media (min-width: 768px) {
  .text-desc {
    font-size: 20px;
    line-height: 105%;
    color: white;
  }
  .section-header {
    font-size: 32px;
    line-height: 105%;
    color: white;
    font-weight: 700;
    margin-bottom: 1.5rem;
    text-align: center;
    text-transform: capitalize;
    letter-spacing: 0;
  }

  .section-header-orange {
    color: #f7bd3a;
    font-weight: 700;
    margin-bottom: 0.5rem;
    text-align: center;
  }

  .section-desc {
    font-size: 18px;
    color: white;
    text-align: center;
    line-height: 110%;
  }

  #efunding-anti-fraud-announcement {
    max-width: 100%;
    margin: auto;
    list-style-position: outside;
  }

  .privacy-card-container {
    background-color: #0288db;
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: center;
    border-radius: 16px;
  }
}

@media (min-width: 1025px) {
  .text-desc {
    font-size: 32px;
    color: white;
  }
  .section-header {
    font-size: 48px;
    color: white;
    font-weight: 700;
    margin-bottom: 1.5rem;
    text-align: center;
    text-transform: capitalize;
    letter-spacing: 0;
  }

  .section-header-orange {
    color: #f7bd3a;
    font-weight: 700;
    margin-bottom: 0.5rem;
    text-align: center;
  }

  .section-desc {
    font-size: 24px;
    color: white;
    text-align: center;
  }

  #efunding-anti-fraud-announcement {
    max-width: 50%;
    margin: auto;
    list-style-position: outside;
  }

  .privacy-card-container {
    background-color: #0288db;
    padding: 50px;
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: center;
    border-radius: 16px;
  }
}

/* Whistleblowing Form Styles */
.whistleblowing-form-container {
  display: flex;
  justify-content: center;
  padding: 0 1rem;
  margin-bottom: 2rem;
}

.whistleblowing-card {
  background-color: #ffffff;
  border-radius: 18px;
  padding: 2rem;
  width: 100%;
  max-width: 700px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.form-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f3a70;
  text-align: center;
  margin-bottom: 2rem;
}

.form-title .text-orange {
  color: #f7bd3a;
}

.whistleblowing-form .form-group {
  margin-bottom: 1.25rem;
}

.whistleblowing-form label {
  display: block;
  font-weight: 700;
  color: #1f3a70;
  margin-bottom: 6px;
  font-size: 14px;
}

.required-star {
  color: #dc3545;
  font-weight: bold;
}

.optional-label {
  color: #888;
  font-weight: 400;
  font-size: 12px;
}

.whistleblowing-form input[type="text"],
.whistleblowing-form input[type="email"],
.whistleblowing-form select,
.whistleblowing-form textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  background-color: #ffffff;
  box-sizing: border-box;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.whistleblowing-form input:focus,
.whistleblowing-form select:focus,
.whistleblowing-form textarea:focus {
  outline: none;
  border-color: #0094cc;
  box-shadow: 0 0 0 3px rgba(0, 148, 204, 0.1);
}

.whistleblowing-form input::placeholder,
.whistleblowing-form textarea::placeholder {
  color: #999;
}

.whistleblowing-form select {
  background-color: #fafafa;
  cursor: pointer;
}
.whistleblowing-form select {
  background-color: #fafafa;
  cursor: pointer;
}

.whistleblowing-form textarea {
  height: 140px;
  resize: vertical;
}

.whistleblowing-form .is-valid {
  border: 2px solid #28a745;
}

.whistleblowing-form .is-invalid {
  border: 2px solid #dc3545;
}

.valid-feedback {
  color: #28a745;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.invalid-feedback {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.form-submit {
  text-align: center;
  margin-top: 1.5rem;
}

.btn-submit {
  background-color: #0094cc;
  border: none;
  padding: 14px 40px;
  color: white;
  font-weight: 600;
  font-size: 16px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-submit:hover {
  background-color: #007aaf;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 148, 204, 0.4);
}

.btn-submit:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.qr-section {
  margin-top: 2rem;
}

/* Modal Styles */
.success-modal-container,
.error-modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.success-icon,
.error-icon {
  width: 150px;
}

.success-text,
.error-text {
  margin-top: 20px;
  margin-bottom: 20px;
}

.success-title {
  display: block;
  font-weight: 700;
  font-size: 24px;
  color: #28a745;
  line-height: 1.2;
}

.success-subtitle {
  display: block;
  font-weight: 700;
  font-size: 20px;
  color: #28a745;
  margin-top: 5px;
}

.error-title {
  display: block;
  font-weight: 700;
  font-size: 24px;
  color: #dc3545;
  line-height: 1.2;
}

.error-subtitle {
  display: block;
  font-weight: 700;
  font-size: 20px;
  color: #dc3545;
  margin-top: 5px;
}

.success-message-box {
  background-color: #d4edda;
  padding: 15px 20px;
  border-radius: 10px;
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
  color: #155724;
  font-weight: 500;
}

.error-message-box {
  background-color: #f8d7da;
  padding: 15px 20px;
  border-radius: 10px;
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
  color: #721c24;
  font-weight: 500;
}

.modal-action-buttons {
  display: flex;
  justify-content: center;
  width: 100%;
}

.custom-btn.btn-close-modal {
  background-color: #0094cc;
  border: none;
  padding: 12px 30px;
  color: white;
  font-weight: bold;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.custom-btn.btn-close-modal:hover {
  background-color: #007aac;
}

/* Responsive Styles for Whistleblowing Form */
@media (max-width: 767px) {
  .whistleblowing-card {
    padding: 1.5rem;
    margin: 0 0.5rem;
  }

  .form-title {
    font-size: 22px;
  }

  .whistleblowing-form label {
    font-size: 13px;
  }

  .whistleblowing-form input[type="text"],
  .whistleblowing-form input[type="email"],
  .whistleblowing-form select,
  .whistleblowing-form textarea {
    font-size: 13px;
    padding: 10px 12px;
  }

  .btn-submit {
    padding: 12px 30px;
    font-size: 14px;
  }

  .success-icon,
  .error-icon {
    width: 120px;
  }

  .success-title,
  .error-title {
    font-size: 20px;
  }

  .success-subtitle,
  .error-subtitle {
    font-size: 16px;
  }
}

@media (min-width: 768px) {
  .whistleblowing-card {
    padding: 2.5rem;
  }
}

@media (min-width: 1025px) {
  .whistleblowing-card {
    padding: 3rem;
    max-width: 800px;
  }

  .form-title {
    font-size: 32px;
  }
}
</style>




// WEBPACK FOOTER //
// src/public/whistleblower.vue